import { DateRangeCalendar } from 'components/DateRangePicker'
import { Button, Dropdown, Search, Toggle, useKeyEvent } from 'monday-ui-react-core'
import React, { useMemo, useState } from 'react'
import { Col } from 'react-bootstrap'
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons'
import './ProductBalancing.scss'
import { Usertype } from 'utils/Constants'

export default function ProductBalancingForm({
    showAdvancedSearch,
    setShowAdvancedSearch,
    setSelectedStatus,
    selectedStatus,
    handleSearchChange,
    handleSearchSubmit,
    setReportingMonthDates,
    type,
    reportingMonthFromValue,
    reportingMonthToValue,
    setShowChart,
    showChart,
    isUnreadFiltered,
    onTabChange,
    errorMessage,
    searchString
}) {
    const [isSearchFocused, setIsSearchFocused] = useState(false)

    useKeyEvent({
        keys: ["Enter"],
        // @ts-ignore
        callback: e => onEnterPressed(e.key)
    });

    const onEnterPressed = (keyName) => {
        if(keyName === 'Enter' && isSearchFocused){
            handleSearchSubmit()
            setIsSearchFocused(true)
        }
    }
    
    const options = useMemo(
        () => [
            {
                value: 1,
                label: 'All statements',
            },
            {
                value: 2,
                label: 'Current & past',
            },
            {
                value: 3,
                label: 'Current only',
            }
        ],
        []
    )

    const optionsSender = useMemo(
        () => [
            {
                value: 1,
                label: 'All statements',
            },
            {
                value: 2,
                label: 'Current & past',
            },
            {
                value: 3,
                label: 'Current only',
            },
            { 
                value: 4,
                label: 'Hidden only',
            }
        ],
        []
    )

    const handleTabClick = (isUnread) => {
        isUnreadFiltered.current = isUnread
        onTabChange()
    }

    return (
        <>
            <Col sm={12} lg={2} className="mt-3">
                <span className="fw-bold statement-status">
                    Statement Status
                </span>
                <Dropdown
                    placeholder="Status"
                    size={Dropdown.size.SMALL}
                    options={(type === Usertype.SENDER ? optionsSender : options)}
                    onChange={setSelectedStatus}
                    clearable={false}
                    className="status-picker w-100"
                    defaultValue={[options[0]]}
                />
                {
                    type === Usertype.RECEIVER && (
                        <div className="d-flex pt-2 pb-2">
                            <p className={`all-statements-inner-tab ${!isUnreadFiltered.current && "active"}`}
                                onClick={() =>
                                    handleTabClick(false)
                                }
                            >
                                All
                            </p>
                            <p className={`all-statements-inner-tab ${isUnreadFiltered.current && "active"}`}
                                onClick={() =>
                                    handleTabClick(true)
                                }
                            >
                                Unread
                            </p>
                        </div>
                    )
                }
            </Col>
            <Col sm={12} lg={4} className="mt-3">
                <span className="fw-bold statement-date">Reporting Month</span>
                <DateRangeCalendar onChange={setReportingMonthDates} from={reportingMonthFromValue} to={reportingMonthToValue}
                />
            </Col>
            <Col sm={12} lg={2} className="mt-3">
                <span></span>
            </Col>
            <Col sm={12} lg={4} className="mt-3">
                <span className="search-container">Search</span>
                <div className="d-flex">
                    <Search id="searchbar"
                        placeholder="Search"
                        size={Search.sizes.SMALL}
                        onChange={handleSearchChange}
                        className="pb-search"
                        onBlur={() => setIsSearchFocused(false)}
                        onFocus={() => setIsSearchFocused(true)}
                        value={searchString}
                    />
                    <Button
                        size={Button.sizes.SMALL}
                        type={Button.types.SUBMIT}
                        onClick={handleSearchSubmit}
                        className="pb-search-button"
                    >
                        Search
                    </Button>
                    {selectedStatus.value === options[1].value && (
                        <span className='toggle-button'>
                            <Toggle
                                onOverrideText="Show Graphic"
                                isSelected={showChart}
                                onChange={() =>
                                    setShowChart(!showChart)
                                }
                            />
                        </span>
                    )}
                </div>
                <div className="d-flex flex-row-reverse pt-2 pb-2">
                    <p
                        className="down-arrow-search-text"
                        onClick={() =>
                            setShowAdvancedSearch(!showAdvancedSearch)
                        }
                    >
                        Advanced Search
                        {showAdvancedSearch ? (
                            <CaretUpFill className="pb-icon" size={15} />
                        ) : (
                            <CaretDownFill className="pb-icon" size={15} />
                        )}
                    </p>
                </div>
            </Col>
        </>
    )
}
